$('.product-main').on('click','.slick-slide',function(){
    const _this = $(this);
    _this.parents('.product-main').addClass('lightbox-open');
    $('body').addClass('lightbox-open-body');
    setTimeout(function(){
        $(window).resize();
        $('.product-slider').slick('slickGoTo', _this.data('slick-index'));
    },500);
});

$('html').on('click','.product-main.lightbox-open .panzoom__wrap',function(){
    $('.product-main').removeClass('lightbox-open');
    $('body').removeClass('lightbox-open-body');
});

$('[data-all-variants], .recharge__input').on('change',function() {
    console.log('change');
    var $form = $(this).closest('form');
    updatePrice($form);
    updateButtons($form);
});

function updateButtons($form) {
    // var $variantsSelector = $form.find('[data-all-variants]');
    // var $optionSelected = $variantsSelector.find('option:selected'); 
    // var available = $optionSelected.data('available');
    // var atc = $('[data-add-to-cart]', $form);
    // var notify = $('[data-btn-notify-me]', $form);
    // setTimeout(() => {
    //     if (available) {
    //         notify.hide();
    //         atc.text(theme.strings.addToCart);
    //         console.log('available');
    //     }
    //     else {
    //         notify.show();
    //         atc.text(theme.strings.soldOut);
    //         console.log('not available');
    //     }
    // }, 100);
}

function updatePrice($form) {
    var fmt = window.theme.formatMoney;
    var $variantsSelector = $form.find('[data-all-variants]');
    var $optionSelected = $variantsSelector.find('option:selected');
    var price = $optionSelected.data('variant-price');
    var comparePrice = $optionSelected.data('variant-compare-price') * 1;
    var discountPrice = $optionSelected.data('discount-variant-price') * 1;
    var isRecharge = $('.recharge__input:checked', $form).attr('id') == "recharge_subscribe" && discountPrice > 0;
    var pack_qty = $optionSelected.data('pack-qty') == "Default Title" ? 70 : $optionSelected.data('pack-qty') * 1;

    if (pack_qty > 0) {
        var costPerRegular = fmt(price / pack_qty);
        var costPerRecharge = fmt(discountPrice / pack_qty);
    }

    if (isRecharge) {
        if (price > comparePrice) {
            comparePrice = price;
        }
        price = discountPrice;
    }


    $('[data-product-price]', $form).text(fmt(price));
    if (comparePrice > 0) {
        var discount = 100 * (comparePrice - price) / comparePrice;
        discount = Math.round((discount + Number.EPSILON) * 100) / 100;
        $('[data-compare-price]', $form).text(fmt(comparePrice)).show();
        $('[data-discount-label]', $form).text(discount + '% Off').show();
    }
    else {
        $('[data-compare-price]', $form).hide();
        $('[data-discount-label]', $form).hide();
    }

    // Bundle packs pricing:
    if (pack_qty > 0) {
        
        $('[data-regular-pack]').text(pack_qty + ' wipes (' + costPerRegular + ' / wipe)');
        $('[data-recharge-pack]').text(pack_qty + ' wipes (' + costPerRecharge + ' / wipe)');
        $('[data-item-cost]', $form).each(function (index, element) {
            var $option = $variantsSelector.find('option').eq(index);
            var pack_qty = $option.data('pack-qty');
            var price = $option.data('variant-price');
            var discountPrice = $option.data('discount-variant-price') * 1;
            if (isRecharge) {
                price = discountPrice
            }
            var cost = fmt(price / pack_qty);
            $(this).text(pack_qty + ' Wipes, ' + cost);
        });
    }


}

$(document).ready(function () {
    setTimeout(function () {
        $('[data-all-variants]').trigger('change');
        $('.recharge__block--subscribe').trigger('click');
    }, 0);
});

var stickyBtn = $('.product-main [data-add-to-cart-wrapper]:not(.sticky-product-add-to-cart) button[data-add-to-cart]');
if( stickyBtn.length != 0 ){

    $(window).on('scroll',function() {

        var stickyBtnTop = stickyBtn.offset().top;
     
        var scrollTop = $(window).scrollTop();
    
        if ( scrollTop + $(window).height() < stickyBtnTop || scrollTop > stickyBtnTop) { 
            $('#addToCartForm [product-option__list]').removeClass('selected');
            $('#addToCartForm [product-option]').hide();     
            $('.sticky-addtocart').addClass('sticky');
        } else {
            $('.sticky-addtocart').removeClass('sticky');
            $('.sticky-addtocart [product-option__list]').removeClass('selected');
            $('.sticky-addtocart [product-option]').hide();
        }
    });
}

$('.sticky-addtocart .product-options select').on('change',function(){
    $(this).parents('#addToCartForm').find( '#'+$(this).attr('id')+'-'+$(this).val() ).trigger('click');
    optionIndex = $(this).data('stickyproduct-option');
    changeOption2(optionIndex);
});

$('#addToCartForm .product-option input[type=radio]').on('change',function(){
    optionIndex = $(this).data('product-option');
    $(this).parents('#addToCartForm').find('[data-stickyproduct-options='+optionIndex+']').val($(this).val());
    changeOption2(optionIndex);
});

function changeOption2(index){
    if( index == 1 ){
        $('[data-stickyproduct-options="2"] option').each(function(){
            var select = $(this).parents('select');
            console.log($(this).parents('#addToCartForm').find( '#'+select.attr('id')+'-'+$(this).attr('value') ));
            if( $(this).parents('#addToCartForm').find( '#'+select.attr('id')+'-'+$(this).attr('value') ).prop('disabled') ){
                $(this).attr('disabled',true);
            }
            else{
                $(this).attr('disabled',false);
            }
        });
        $('#addToCartForm .product-option input[type=radio][data-product-option="2"]:checked').trigger('change');
    }
}


$("body").on('DOMSubtreeModified', ".sticky-addtocart [data-add-to-cart]", function() {
    var $variants = $('#addToCartForm [data-all-variants] option:selected');
    const productMain = $('.product-main');
    if( productMain.find('[name="recharge"]:checked').attr('id') == "recharge_subscribe" ){
        var old_price = $variants.data('variant-price');
        var price = $variants.data('discount-variant-price');
        if (old_price > price ) {
            if ($('.sticky-addtocart [data-add-to-cart] .old-price').length === 0) {
             $('.sticky-addtocart [data-add-to-cart]').prepend('<span class="old-price">'+ '$'+(old_price/100).toFixed(2)+'</span> ');   
            }
        }
    }
});


/* Upsell product with options */

$('html').on('click','[product-upsell-item-pdp]:not(.active) [product-upsell-item-pdp-top]', function(){
    var upsellWrapper = $(this).closest('[product-upsell-item-pdp]');
    totalOptions = upsellWrapper.find('[data-product-upsell-options]').data('total-options');
    option1lenght = upsellWrapper.find('[data-upsell-product-option-pdp="1"]').length;
    option2lenght = upsellWrapper.find('[data-upsell-product-option-pdp="2"]').length;

    if (totalOptions == 2 && ( option1lenght == 1 || option2lenght == 1 )) {
        upsellWrapper.toggleClass('active');
        upsellWrapper.toggleClass('open');
        upsellWrapper.find('.upsell-atc input[data-upsell-item]').prop('checked', true).trigger('change');
    } else {
        if (upsellWrapper.hasClass('is-default')) {
            upsellWrapper.toggleClass('active');
            upsellWrapper.find('.upsell-atc input[data-upsell-item]').prop('checked', true).trigger('change');
        } else {
            upsellWrapper.toggleClass('open');
        }
    }
});

$('.upsell-atc input[data-upsell-item]').off('change').on('change',function(e){
    var checked = $(this).prop('checked');
    var upsellWrapper = $(this).closest('[product-upsell-item-pdp]');

    if (!checked) {
        if (upsellWrapper.hasClass('is-default')) {
            upsellWrapper.removeClass('active');
        } else {
            upsellWrapper.removeClass('active');
            upsellWrapper.removeClass('open');
        }
        upsellWrapper.find('input[name^="product-upsell-pdp-option-size"][data-upsell-product-option-pdp]').each(function () { 
            $(this).prop('checked', false); 
        });
        upsellWrapper.find('[data-selected-size__name]').html('<span class="notification"> select a size to add </span>');
    }
});

$('[product-upsell-item-pdp] .product-upsell-pdp-option input[type=radio]').on('change', function(e){
    e.preventDefault();

    optionProductId = $(this).data('product-id');
    optionIndex = $(this).data('upsell-product-option-pdp');
    upsellWrapper = $(this).closest('[product-upsell-item-pdp][data-id='+ optionProductId +']');
    totalOptions = upsellWrapper.find('[data-product-upsell-options]').data('total-options');
    upsellId = upsellWrapper.data('id');

    console.log("optionIndex ", optionIndex);

    option1 = upsellWrapper.find('[data-upsell-product-option-pdp="1"]:checked').val();
    option2 = upsellWrapper.find('[data-upsell-product-option-pdp="2"]:checked').val();
    option3 = upsellWrapper.find('[data-upsell-product-option-pdp="3"]:checked').val();

    option1 = (typeof option1 != 'undefined' ? option1 : '_BLANK_');
    if (typeof option2 == 'undefined' && upsellWrapper.find('[data-upsell-product-option-pdp="2"]').length > 0) {
        option2 = upsellWrapper.find('[data-upsell-product-option-pdp="2"]:first').val();
    }
    option2 = (typeof option2 != 'undefined' ? option2 : '_BLANK_');
    if (typeof option3 == 'undefined' && upsellWrapper.find('[data-upsell-product-option-pdp="3"]').length > 0) {
        option3 = upsellWrapper.find('[data-upsell-product-option-pdp="3"]:first').val();
    }
    option3 = (typeof option3 != 'undefined' ? option3 : '_BLANK_');
   
    console.log("OPTIONS ", option1, option2, option3);
    var currentOption = upsellWrapper.find('[data-all-variants-upsell] option[data-option1="'+ option1 +'"][data-option2="'+ option2 +'"][data-option3="'+ option3 +'"]');

    currentOption.prop('selected', true).change();
    
    // Update image
    var optionImage = currentOption.data('option-image');
    if (!optionImage.includes('no-image') ) {
        upsellWrapper.find('.image_wrapper .rimage img ').attr('src', optionImage);
        upsellWrapper.find('.image_wrapper .rimage img ').attr('srcset', '');       
    }

    
    // Update price
    /*var optionVariantPrice = currentOption.data('variant-price');
    optionVariantPrice = Shopify.formatMoney(optionVariantPrice);
    upsellWrapper.find('.upsell-item_price').text(optionVariantPrice);*/

    // Update upsell ID
    var optionVariantId = currentOption.val();
    upsellWrapper.data('id', optionVariantId);
    upsellWrapper.find('.upsell-atc input[data-upsell-item]').data('id', optionVariantId);
    
    option1lenght = upsellWrapper.find('[data-upsell-product-option-pdp="1"]').length;
    option2lenght = upsellWrapper.find('[data-upsell-product-option-pdp="2"]').length;

    if (optionIndex == 2 || totalOptions == 1 || (totalOptions == 2 && ( option1lenght == 1 || option2lenght == 1 ))) {
        upsellWrapper.find('[data-selected-size__name]').text($(this).val());
        upsellWrapper.addClass('active');
        upsellWrapper.find('.upsell-atc input[data-upsell-item]').prop('checked', true).trigger('change');
    }
    
    changeOption3(optionIndex, upsellId);
});

function changeOption3(index, id){
    
    switch (index) {
        case 1:
            $('[product-upsell-item-pdp][data-id='+ id +'] [data-upsell-product-option-pdp="2"]').each(function(){ 
                var option1 = $(this).closest('[product-upsell-item-pdp]').find('[data-all-variants-upsell] option:selected').data('option1');
                var option2 = $(this).val();
                var current = $(this).closest('[product-upsell-item-pdp]').find('[data-all-variants-upsell] option[data-option1="'+ option1 +'"][data-option2="'+ option2 +'"]').data('available');
                if( current == null || current == "false" ){
                    $(this).attr('disabled',true);
                }  else{
                    $(this).attr('disabled',false);
                }
            });
            break;
        case 2:
            $('[product-upsell-item-pdp][data-id='+ id +'] [data-upsell-product-option-pdp="1"]').each(function(){ 
                var option2 = $(this).closest('[product-upsell-item-pdp]').find('[data-all-variants-upsell] option:selected').data('option2');
                var option1 = $(this).val();
                var current = $(this).closest('[product-upsell-item-pdp]').find('[data-all-variants-upsell] option[data-option1="'+ option1 +'"][data-option2="'+ option2 +'"]').data('available');
                if( current == null || current == "false" ){
                    $(this).attr('disabled',true);
                }  else{
                    $(this).attr('disabled',false);
                }
            });
            break;
        default:
            break;
    }
}

$('html').on('click','[product-upsell-item-pdp] .remove-upsell', function(e){
    e.preventDefault();
    var upsellWrapper = $(this).closest('[product-upsell-item-pdp]');
    upsellWrapper.removeClass('active').removeClass('open');
    upsellWrapper.find('.upsell-atc input[data-upsell-item]').prop('checked', false).trigger('change');
    upsellWrapper.find('input[name^="product-upsell-pdp-option-size"][data-upsell-product-option-pdp]').each(function () { 
        $(this).prop('checked', false); 
    });
    upsellWrapper.find('[data-selected-size__name]').html('<span class="notification"> select a size to add </span>');
});


$('[data-popup="size-chart-upsell"] .close-size-chart-upsell').off('click').on('click',function(e){
    e.preventDefault();
    $('[data-popup="size-chart-upsell"]').addClass("is-hidden");
    $("body").removeClass("popup-open");
});


// extend tabs feature
$('[data-tab-close]').on('click', function () {
    var $this = $(this);
    if ($this.hasClass('is-active')) {
        setTimeout(function() {
            var $parent = $this.closest('[data-tabs]');
            $parent.find('[data-tab-content]').removeClass('is-active');
            $this.removeClass('is-active');
        }, 250);
    }
})

// Add the conversion tracker to the button's click handler

var addToCartButtons = document.querySelectorAll('#addToCartForm button.add-to-cart');
var _learnq = _learnq || [];

addToCartButtons.forEach( (addToCartButton) => {
    addToCartButton.addEventListener("click",function() { 
      _learnq.push(['track', 'Added to Cart', item]);
		!function(s,a,e,v,n,t,z){if(s.saq)return;n=s.saq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!s._saq)s._saq=n;n.push=n;n.loaded=!0;n.version='1.0';n.queue=[];t=a.createElement(e);t.async=!0;t.src=v;z=a.getElementsByTagName(e)[0];z.parentNode.insertBefore(t,z)}(window,document,'script','https://tags.srv.stackadapt.com/events.js');saq('conv', 'ISslijvCk1mgbpMwi7pdzZ'); 
	});
})
